export default __webpack_public_path__ + "static/media/playstore.7a44b6ef.jpg";